import React, { useEffect, useState } from 'react'

import * as RadioGroup from '@radix-ui/react-radio-group'

import { RadioListProps } from './RadioList.types'

import './RadioList.scss'

export const RadioList: React.FC<RadioListProps> = ({ 
  items,
  name,
  onChange,
  value
}) => {

  const [val, setVal] = useState(value)

  useEffect(() => {
    setVal(value)
  }, [value])

  useEffect(() => {
    onChange && onChange(val)
  },[onChange, val])

  const handleChange = (value) => {
    setVal(value)
  }

  return (
    <RadioGroup.Root 
      value={val}
      style={{
        display:'flex',
        gap:10,
        flexDirection: 'column',
        padding: '16px 8px',
        borderTop: '1px solid var(--primary)',
      }}
      name={name}
      onValueChange={handleChange} 
    >
      <>{
        items.map((item, i) => {
          return (
            <div key={`${item}-${i}`}
              style={{
                display:'flex',
                gap: 12,
                alignItems: 'center'
              }}
            >
              <RadioGroup.Item 
                value={item} 
                id={`${item}`} 
                className='poll-radio'
                style={{
                  outline: 'none'
                }}
              >
                <RadioGroup.Indicator className='poll-radio-indicator'/>
              </RadioGroup.Item>
              {/* bandaid to show abbreviated units in uppercase */}
              <label 
                style={{
                  marginBottom: 0,
                  cursor: 'pointer'
                }}
                htmlFor={`${item}`}>{
                  name === 'units' ?
                    item.toUpperCase()
                    :
                    (item.charAt(0).toUpperCase() + item.slice(1)).split('-').join(' ')
                }
              </label>
            </div>
          )
        })
      }</>
    </RadioGroup.Root>
  )
}

export default RadioList

